import { Box, Stack } from '@mui/material';
import { BigNumber } from 'bignumber.js';
import { useState } from 'react';

import { Button, Input, Modal, Separator, TextButton, Typography } from '@/design-system';
import { colors } from '@/shared/design-system/colors';

import { fmtAmount } from './formatters';
import { CoinModalProps } from './types';

export const SellModal = ({ open, onClose, coin }: CoinModalProps) => {
  const [amount, setAmount] = useState('');
  const handleClose = () => {
    setAmount('');
    onClose();
  };
  const estimatedUsd =
    coin.price != null && Number(amount) > 0 ? coin.price * Number(amount) : null;
  const exactAmount = new BigNumber(amount);
  const amountValid =
    exactAmount.isFinite() &&
    exactAmount.isGreaterThan(0) &&
    exactAmount.isLessThanOrEqualTo(coin.balance);

  return (
    <Modal
      open={open}
      onOpenChange={(next) => {
        if (!next) handleClose();
      }}
      title={`Sell ${coin.symbol}`}
      showClose
      maxWidth={420}
    >
      <Stack gap="20px" flexDirection="column">
        <Separator tone="subtle" />
        <Box bgcolor="#1E2333" border="1px solid #2E3348" borderRadius="10px" p="12px 16px">
          <Stack direction="row" justifyContent="space-between">
            <Typography variant="body4" color={colors.text.secondary}>
              Available
            </Typography>
            <Typography variant="body4">
              {fmtAmount(coin.balance)} {coin.symbol}
            </Typography>
          </Stack>
          {coin.price != null && (
            <Stack direction="row" justifyContent="space-between" mt="6px">
              <Typography variant="body4" color={colors.text.secondary}>
                Current price
              </Typography>
              <Typography variant="body4">${coin.price.toFixed(4)}</Typography>
            </Stack>
          )}
        </Box>
        <Input
          label={`Amount to sell (${coin.symbol})`}
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
          placeholder="0.00"
          type="number"
          endControl={
            <TextButton type="button" onClick={() => setAmount(coin.balance.toFixed())}>
              MAX
            </TextButton>
          }
        />
        {estimatedUsd != null && (
          <Typography variant="body4" color={colors.text.secondary} align="center">
            Estimated proceeds: <strong>${estimatedUsd.toFixed(2)} USD</strong>
          </Typography>
        )}
        <Stack gap="12px">
          <Button color="warning" size="lg" disabled={!amountValid} onClick={handleClose}>
            Sell {coin.symbol}
          </Button>
          <Button color="secondary" variant="subtle" size="lg" onClick={handleClose}>
            Cancel
          </Button>
        </Stack>
      </Stack>
    </Modal>
  );
};
